export enum CustomValidationRule {
	editableSelectOptionsRequired = 'editable-select-options-required',
	copyFormRequired = 'copy-form-required'
}
